module.exports = __webpack_public_path__ + "img/thermometer_grey.11a24183.svg";